module.exports = __webpack_public_path__ + "img/IMG_9512_L.fe2d79fe.webp";